export const downloadFile = (data, filename, extension = ".csv") => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = filename + extension;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
